export const tourTypes = (state) => state.tourTypes;
